import {forwardRef} from 'react';
import cx from 'classnames';

import {CardComponent, CardProps} from './Card.types';

import * as css from './Card.css';

/**
 * A `Card` is a multi-purpose container element that may contain content and
 * actions about a single subject.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags. This
 * component may have it's underlying DOM customized via the 'as' prop.
 */
export const Card: CardComponent = forwardRef(
  <T extends React.ElementType = 'div'>(
    {as, className, variant = 'cotton', ...otherProps}: CardProps<T>,
    ref: PolymorphicRef<T>,
  ) => {
    const Component = as || 'div';

    return <Component className={cx(css.root({variant}), className)} {...otherProps} ref={ref} />;
  },
);
